<div class="flex flex-col px-4 gap-6 lg:px-0 lg:max-w-6xl lg:mx-auto pt-6 lg:py-12 w-full">
  @if (data(); as gallery) {
  <!-- 목록으로 버튼 -->
  <button routerLink=".." class="cursor-pointer flex items-center gap-1 hover:text-zinc-600 transition-colors w-fit">
    <app-icon name="mdi:chevron-left" class="size-5! text-zinc-300" />
    <span class="text-zinc-400 font-medium">목록으로</span>
  </button>

  <div class="flex flex-col gap-3">
    <h1 class="sb-aggro text-lg lg:text-3xl font-light text-zinc-800">
      {{ gallery.title }}
    </h1>
    <div class="text-sm text-zinc-400 font-medium">
      {{ gallery.displayDate || gallery.createdAt | date : 'yyyy-MM-dd HH:mm' }}
    </div>
  </div>

  <div class="w-full h-px bg-zinc-100"></div>

  <!-- 미디어 영역 -->
  <div class="flex flex-col gap-4 items-center">
    @if (gallery.type === 'VIDEO' && gallery.videoLink) {
    <!-- 동영상 -->
    <div class="aspect-video w-full max-w-4xl">
      <app-gallery-video-player [src]="gallery.videoLink" class="w-full h-full rounded-lg" />
    </div>
    } @else if (gallery.type === 'PHOTO' && gallery.photos && gallery.photos.length > 0) {
    <!-- 사진 갤러리 -->
    <div class="grid grid-cols-1 gap-4">
      @for (photo of gallery.photos; track $index) {
      <button
        type="button"
        class="relative w-full bg-zinc-900 rounded-xl object-contain"
        (click)="openImageModal(photo)">
        <img [src]="photo" [alt]="gallery.title" class="w-full h-full object-contain" />
      </button>
      }
    </div>
    }
  </div>

  <!-- 이전글/다음글 영역 -->
  <div class="flex flex-col border-y border-zinc-100">
    <!-- 이전글 -->
    @if (prevGallery(); as prev) {
    <div
      [routerLink]="['..', prev.id]"
      class="flex items-center gap-3 p-6 border-b border-zinc-100 hover:bg-zinc-50 transition-colors cursor-pointer">
      <span class="text-sm text-zinc-400 font-medium shrink-0"> 이전글 </span>
      <span class="text-sm text-zinc-800 font-medium flex-1 truncate">
        {{ prev.title }}
      </span>
      <span class="text-sm text-zinc-400 shrink-0 font-medium">
        {{ prev.displayDate || prev.createdAt | date : 'yyyy.MM.dd' }}
      </span>
    </div>
    } @else {
    <div class="flex items-center gap-3 p-6 border-b border-zinc-100">
      <span class="text-sm text-zinc-400 font-medium shrink-0"> 이전글 </span>
      <span class="text-sm text-zinc-400 flex-1"> 이전 글이 없습니다. </span>
    </div>
    }

    <!-- 다음글 -->
    @if (nextGallery(); as next) {
    <div
      [routerLink]="['..', next.id]"
      class="flex gap-3 items-center p-6 hover:bg-zinc-50 transition-colors cursor-pointer">
      <span class="text-sm text-zinc-400 font-medium shrink-0"> 다음글 </span>
      <span class="text-sm text-zinc-800 font-medium flex-1 truncate">
        {{ next.title }}
      </span>
      <span class="text-sm text-zinc-400 shrink-0 font-medium">
        {{ next.displayDate || next.createdAt | date : 'yyyy.MM.dd' }}
      </span>
    </div>
    } @else {
    <div class="flex items-center gap-3 p-6">
      <span class="text-sm text-zinc-400 font-medium shrink-0"> 다음글 </span>
      <span class="text-sm text-zinc-400 flex-1"> 다음 글이 없습니다. </span>
    </div>
    }
  </div>

  <!-- 하단 목록으로 버튼 -->
  <div class="flex justify-center">
    <button
      routerLink=".."
      class="cursor-pointer w-full lg:w-[30%] py-2 border border-zinc-200 text-zinc-800 rounded-lg font-medium">
      목록으로
    </button>
  </div>
  }

  <!-- 이미지 모달 -->
  @if (selectedImage()) {
  <div
    role="button"
    tabindex="0"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 p-4"
    (click)="closeImageModal()"
    (keydown.enter)="closeImageModal()"
    (keydown.space)="closeImageModal()">
    <div class="relative max-w-7xl max-h-full">
      <button
        type="button"
        class="absolute top-4 right-4 text-white cursor-pointer rounded-full p-2 hover:bg-opacity-75"
        (click)="closeImageModal()">
        <app-icon name="mdi:close" size="lg" />
      </button>
      <img [src]="selectedImage()" alt="확대된 갤러리 사진" class="max-w-full max-h-[90vh] object-contain rounded-lg" />
    </div>
  </div>
  }
</div>
